import { useState, Fragment, useEffect } from "react";
import styles from "Components/Dashboard/dashboard.module.scss";
import { Card, Tooltip, Checkbox, Typography, Button, Grid } from "antd";
import MarkerClusterGroup from "react-leaflet-markercluster";
import { Map, Marker, Popup, TileLayer } from "react-leaflet";
import { Icon, Point } from "leaflet";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "store/hook";
import { setFilter } from "Components/Topology/Device/deviceTableSlice";
import { divIcon } from "leaflet";
import { renderToStaticMarkup } from "react-dom/server";
import { TiLocation } from "react-icons/ti";
import Control from "react-leaflet-control";
import { TimestampToDate } from "Utility/Fetch";
import { useStatistic, useDeviceStatus } from "../../queries";
import { useGetCoordinate } from "../../../Topology/queries";
import { ControlOutlined } from "@ant-design/icons";
import { TableData } from "Utility/Types/status_identity_get_set";

const { Text } = Typography;
const { useBreakpoint } = Grid;
//定義一個函數，根據狀態(status)返回不同的地圖圖標
export const MapIcon = (status: string) => {
  return new Icon({
    iconUrl:
      status === "alarm"
        ? "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png"
        : "https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png",
    shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [35, 50], //圖標大小
    iconAnchor: [12, 41], //圖標錨點
    popupAnchor: [1, -34], //彈出窗口的錨點
    shadowSize: [41, 41], //陰影大小
  });
};

const DashboardMapC = () => {
  const { loginCid, stateCid, level, isLogin, time_zone, isDarkMode } = useAppSelector((state) => state.global);
  const { data: deviceStatistic, isSuccess } = useStatistic(level, stateCid, loginCid, isLogin);
  const { data: deviceStatus } = useDeviceStatus(level, stateCid, loginCid, isLogin);

  const ids = isSuccess && deviceStatus?.response?.devicesID;
  const { data: gpsData, refetch } = useGetCoordinate(ids);
  const { isMapOnly } = useAppSelector((state) => state.dashboard);
  const screens = useBreakpoint();
  const screenHeight = window.innerHeight;

  const disp = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  //設定地圖視圖的初始(位置)狀態
  const [viewport, setViewPort] = useState({
    center: [24.793256, 121.013987],
    zoom: 8,
  });
  // 設定地圖上的標記聚類行為
  const [disableClusteringAtZoom] = useState(19);
  // 從設備狀態信息中獲得表格數據
  const tableData = deviceStatus?.response?.tableData || [];
  // 創建 GPS 數據列表，初始化為表格數據
  const [GPSList, setGPSList] = useState(tableData);
  // 控制是否顯示設備ID "show ID" 是否顯示
  const [showDeviceOnMap, setShowDeviceOnMap] = useState(false);
  // 控制是否顯示設備位置 "show Location" 是否顯示
  const [showLocation, setShowLocation] = useState(false);
  // 控制是否只顯示警報設備 "Alarm Only" 是否顯示
  const [showAlarmOnly, setShowAlarmOnly] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const [markersSpiderfyOpen, setMarkersSpiderfyOpen] = useState(59);

  // 從設備統計訊息中取得設備"健康狀態"和"訊號強弱" 數量
  const health = deviceStatistic?.health;
  const signal = deviceStatistic?.sim;

  useEffect(() => {
    // refetch();
    // const tableDataCopy: any = JSON.parse(JSON.stringify(tableData));
    // for (let i = 0; i < tableDataCopy?.length; i++) {
    //   for (let j = 0; j < gpsData?.length; j++) {
    //     if (tableDataCopy[i].id === gpsData[j].id) {
    //       tableDataCopy[i].lati_longi = "123";
    //     }
    //   }
    // }
    // 渲染頁面時取得GPS設備的數據資料
    setGPSList(tableData);
  }, [tableData.length]);

  useEffect(() => {
    const localViewport = localStorage.getItem("viewport");
    if (!localViewport) {
      return;
    }
    setViewPort(JSON.parse(localViewport));
  }, []);
  //  定義自訂的圖標渲染方式
  const customMarkerIcon = (value: any, index: number, health: string, city: string) =>
    divIcon({
      // 增加 className: "" 使 .leaflet-div-icon 預設CSS樣式失效，移除空格。
      className: "",
      html: renderToStaticMarkup(
        /* 1、在 <p> 標籤 加入 style={{whiteSpace: "nowrap", display: "inline"}：使樣式空白不換行，解決location、type 字體垂直顯示問題，
              確保文字內容不換行，並將元素以行內方式顯示在同一行上。
           2、TODO: 新增 <div> 將 <p> 標籤的文字包覆並給予背景色，需使用 style={{display: "inline-block"} 才能使 <p>標籤內文字撐開 <div>
        */
        <div key={index} style={{ whiteSpace: "nowrap", display: "inline" }}>
          <TiLocation
            style={
              health === "up"
                ? // TODO: 使用 fontSize 將 標記 拉大後，會產生座標位置移位，使用marginTop，marginLeft 拉回正確位置。
                  { color: "#006400", fontSize: "2rem", marginTop: "-22px", marginLeft: "-10px" }
                : { color: "#dc3545", fontSize: "2rem", marginTop: "-22px", marginLeft: "-10px" }
            }
          />
          {/* 點選 show ID 並勾選 顯示左邊樣式  若沒有勾選 則顯示右邊樣式 display:'none' = 移除 show ID 組件*/}
          <div
            style={
              showDeviceOnMap || showLocation
                ? {
                    backgroundColor: isDarkMode ? "#141414" : "#fff",
                    opacity: "0.85",
                    border: `1px solid ${isDarkMode ? "#fff" : "#002fa7"}`,
                    borderRadius: "10px",
                    padding: "5px",
                    display: "inline-block", // 將 div 設定為行內區塊，就可以使p段落文字撐開div
                  }
                : { display: "none" }
            }
          >
            <p
              style={
                showDeviceOnMap
                  ? { fontWeight: "bold", marginBottom: "3px", whiteSpace: "nowrap", display: "inline" }
                  : { display: "none" }
              }
            >
              {value}
              <br />
            </p>
            {/* 點選 Show Location 並勾選 顯示左邊樣式  若沒有勾選 則顯示右邊樣式 display:'none' = 移除 Show Location 組件*/}
            <p
              style={
                showLocation ? { fontWeight: "bold", whiteSpace: "nowrap", display: "inline" } : { display: "none" }
              }
            >
              {city}
            </p>
          </div>
        </div>
      ),
    });

  // 彈出窗口的點擊事件
  const onPopCkick = (item: TableData) => {
    disp(setFilter({ name_or_id: [item.name_or_id] }));
    navigate("./overview");
  };
  // 將地圖變化事件，狀態保存在本地儲存
  const onViewportChanged = (viewport: any) => {
    localStorage.setItem("viewport", JSON.stringify(viewport));
  };

  // TODO: 新增 useEffect 來即時更新 setMarkersSpiderfyOpen 值
  useEffect(() => {
    if (showLocation && showDeviceOnMap) {
      setMarkersSpiderfyOpen(77);
    } else if (showLocation || showDeviceOnMap) {
      setMarkersSpiderfyOpen(59);
    }
  }, [showLocation, showDeviceOnMap]);

  // TODO: 新增 markersSpiderfy 將 標記群組自訂義
  const markersSpiderfy = (count: any, centerPt?: any) => {
    // 每個標記相對於中心點的橫向距離
    var distanceFromCenter = 45,
      // 展開時上下間距的參數
      markerDistance = markersSpiderfyOpen,
      // 計算連接線的總長度，count 表示標記的數量
      lineLength = markerDistance * (count - 1),
      // 計算連接線的起始位置，centerPt.y 表示中心點的縱坐標
      lineStart = centerPt.y - lineLength / 2,
      // 初始化一個空陣列，用於存儲計算得到的位置信息
      res = [],
      i;
    // 設置陣列 res 的長度為 count，表示存儲 count 個位置信息
    res.length = count;

    for (i = count - 1; i >= 0; i--) {
      // 計算第 i 個標記的位置
      // new Point 表示創建一個 Leaflet 的點對象，
      // 其中 centerPt.x + distanceFromCenter 表示橫坐標，
      // lineStart + markerDistance * i 表示縱坐標
      res[i] = new Point(centerPt.x + distanceFromCenter, lineStart + markerDistance * i);
    }
    // 返回包含位置信息的陣列 res
    return res;
  };

  return (
    // 使用 Antd 的 Card 組件來製作卡片

    <Card
      bodyStyle={
        isMapOnly
          ? // 若 【"isMapOnly"為 true】 Map 執行下面的 css 來設置 Map 樣式
            { padding: "6px 6px 25px 6px", height: "calc(100vh - 110px)" }
          : // 若 【"isMapOnly"為 false 且 screens.xxl 為 true】 Map 執行下面的 css 來設置 Map 樣式 TODO: 新增 screens.xxl 判斷 測試 2k 螢幕狀態下顯示正常
          screens.xxl
          ? { padding: "6px 6px 25px 6px", height: "calc(100vh -  470px)" }
          : // 若 【"isMapOnly"為 false 且 screens.lg 為 true 螢幕高度高於 1700】 Map 執行下面的 css 來設置 Map 樣式
          screens.lg && screenHeight > 1700
          ? { padding: "6px 6px 25px 6px", height: "calc(100vh -  835px)" }
          : // 若 【"isMapOnly"為 false 且 screens.xxl 為 false】 Map 執行下面的 css 來設置 Map 樣式
            { padding: "6px 6px 25px 6px", height: "400px" }
      }
      className={`${styles.Card} ${styles.MapCard}`}
    >
      <Fragment>
        {/* 創建地圖組件 */}
        {/* @ts-ignore */}
        <Map
          // @ts-ignore 意思是不管這裡有沒有錯，ts 都不要理他
          viewport={viewport}
          className={styles.DashboardMap}
          onViewportChanged={onViewportChanged}
          // TODO: key 的變化可以確保 Leaflet 正確的銷毀舊地圖並重新創建渲染新的地圖，常用於地圖的動態切換管理保持正確性。
          /* 1、當 "isMapOnly"，React 會使用新的 key 值，強制 Map 組件進行重新渲染，以確保地圖的顯示和非顯示狀態得到正確更新。
             2、當 "screens.xxl"，React 會使用新的 key 值，強制 Map 組件重新渲染，以確保地圖能正確顯示。
                沒有加入的話 當 "isMapOnly" 或 "screens.xxl" 地圖會渲染不完全，這裡可以把它當作是個依賴項，當這兩種判斷成立則渲染地圖樣式*/
          key={`${isMapOnly}-${screens.xxl}`}
        >
          {/* 創建地圖瓦片圖層 */}
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            className="tileMap"
          />
          {/* 地圖控制 show ID 儀表盤 */}
          <Control position="topright">
            <div
              style={isMapOnly ? { marginTop: "2rem" } : {}}
              className={styles.mapButton}
              onClick={() => {
                setIsHover((prev) => !prev);
              }}
              onMouseEnter={() => {
                setIsHover(true);
              }}
              onMouseLeave={() => {
                setIsHover(false);
              }}
            >
              {isHover ? (
                <div style={{ width: "150px", display: "flex", flexDirection: "column" }}>
                  <Checkbox
                    checked={showDeviceOnMap}
                    style={{ marginLeft: "8px" }}
                    onChange={() => setShowDeviceOnMap(!showDeviceOnMap)}
                  >
                    {t("ISMS.Show ID")}
                  </Checkbox>
                  <Checkbox checked={showLocation} onChange={() => setShowLocation(!showLocation)}>
                    {t("ISMS.Show Location")}
                  </Checkbox>
                  <Checkbox
                    checked={showAlarmOnly}
                    onChange={(e: any) => {
                      if (e.target.checked) {
                        let alarmNodes = tableData?.filter((item: any) => item.health !== "up");
                        setGPSList(alarmNodes);
                      } else {
                        setGPSList(tableData);
                      }
                      setShowAlarmOnly(e.target.checked);
                    }}
                  >
                    {t("ISMS.Alarm only")}
                  </Checkbox>
                </div>
              ) : (
                <ControlOutlined className={styles.mapIcon} />
              )}
            </div>
          </Control>
          {/* 創建設備標記群組 */}
          {/* disableClusteringAtZoom = {disableClusteringAtZoom } = useState(15) 
                    再縮放級別15 以下禁用聚類 (將相近圖標合併 )
                */}
          <MarkerClusterGroup
            disableClusteringAtZoom={disableClusteringAtZoom}
            removeOutsideVisibleBounds={true}
            // TODO: 群組展開線距離 預設為 1，當圖標過大有遮擋時可適時增大
            // spiderfyDistanceMultiplier={2.7}
            // TODO: 自訂義群組展開樣式
            spiderfyShapePositions={markersSpiderfy}
            // TODO: markersSpiderfyOpen 改變時 會重新渲染 MarkerClusterGroup
            key={markersSpiderfyOpen}
          >
            {GPSList?.map((item, index) => {
              // 取得標記的位置座標
              const position = !item.lati_longi || item.lati_longi === "" ? [0, 0] : item.lati_longi;

              return (
                // 創建地圖標記
                <Marker
                  key={index}
                  position={position}
                  icon={customMarkerIcon(item.name_or_id, index, item.health, item.city)}
                >
                  {/* 創建標記的彈出窗口，顯示該設備資訊 */}
                  {/* TODO: 註: 新增 offset 將 彈出窗口 移至 marker 上方對齊，避免重疊 */}
                  <Popup key={index} offset={[0, -13]}>
                    {t("ISMS.Device")}: {item.name_or_id}
                    <br />
                    {t("ISMS.Status")}: {item.health}
                    <br />
                    {t("ISMS.Signal")}: {item.strength}
                    <br />
                    {t("ISMS.LastUpdate")}:{TimestampToDate(item.lastupdate * 1000, time_zone)}
                    <br />
                    <Button type="link" style={{ padding: 0 }} onClick={() => onPopCkick(item)}>
                      {t("ISMS.view detail")}
                    </Button>
                  </Popup>
                </Marker>
              );
            })}
          </MarkerClusterGroup>
        </Map>
        {/*【地圖 Marker 資訊】 
          螢幕 < 576px : 為 true 不顯示 Fragment，為 false 顯示 Fragment 並套用 styles.markerWrapper 樣式*/}
        <div className={screens.xs ? "" : styles.markerWrapper}>
          {!screens.xs && (
            <Fragment>
              <TiLocation style={{ color: "#006400", fontSize: "1.4rem" }} />
              <Text>{t("ISMS.Good")}</Text>

              <TiLocation style={{ color: "#dc3545", fontSize: "1.4rem" }} />
              <Text>{t("ISMS.Alarm")}</Text>
            </Fragment>
          )}
          {/* 【地圖 數據機設備 (health)健康狀態資訊】
              如果 health 有資料為 true 顯示   * health.up / health.warning /health.critical / health.offline *  資訊
          */}
          <div className="ml-auto">
            {health && (
              <span style={{ fontWeight: 800, fontSize: 12 }}>
                <Text>{t("ISMS.Health")}:</Text>
                <Tooltip placement="top" title={"Up"}>
                  <span style={{ color: "#28a745" }}> {health.up}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Warning"}>
                  <span style={{ color: "#ffc107" }}> {health.warning}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Critical"}>
                  <span style={{ color: "#dc3545" }}> {health.critical}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Offline"}>
                  <span style={{ color: "#343a40" }}>{health.offline}</span>
                </Tooltip>
              </span>
            )}
            {/* 【地圖 數據機設備 (Signal)訊號狀態資訊】
              如果 Signal 有資料為 true 顯示   * signal.excellent / signal.good / signal.fair / signal.poor *  資訊
            */}
            {signal && (
              <span className="ml-3 mr-1" style={{ fontWeight: 800, fontSize: 12 }}>
                <Text>{t("ISMS.Signal")}:</Text>
                <Tooltip placement="top" title={"Excellent"}>
                  <span style={{ color: "#28a745" }}> {signal.excellent}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Good"}>
                  <span style={{ color: "#ffc107" }}> {signal.good}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Fair"}>
                  <span style={{ color: "#dc3545" }}> {signal.fair}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"Poor"}>
                  <span style={{ color: "#343a40" }}>{signal.poor}</span>
                </Tooltip>
                /
                <Tooltip placement="top" title={"NA"}>
                  <span style={{ color: "gray" }}>{signal.na}</span>
                </Tooltip>
              </span>
            )}
          </div>
        </div>
      </Fragment>
    </Card>
  );
};

export default DashboardMapC;
